import { connect } from 'react-redux';
import { removeImportedFile } from 'redux-core/import-cuesheet/actions';

const mapDispatchToProps = { removeImportedFile };

export default connect(null, mapDispatchToProps);
